import React, { useEffect, useRef, useState } from "react";
import { Alert, message, Button, Col, Card, Row, Modal } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { setItem, getItem, checkUser, validUser } from "utils";
import ReactCodeInput from "react-verification-code-input";

import history from "../../services/history";

const defaultCoolDownSeconds = 30;

export default function TokenConfirm({
  type,
  isModalVisible,
  setModalType,
  userFullName,
  userPhone,
  userEmail,
  changeStep,
  taxId,
}) {
  const [loading, setLoading] = useState(false);
  const [sendButtonEnabled, setSendButtonEnabled] = useState(false);
  const [seconds, setSeconds] = useState(defaultCoolDownSeconds);
  const [tokenValidationId, setTokenValidationId] = useState("");
  const codeInput = useRef(null);
  const [isFirstTry, setIsFirstTry] = useState(true);

  const companyId = getItem("companyId");

  useEffect(() => {
    let timer = null;

    if (isModalVisible) {
      if (seconds > 0) {
        timer = setTimeout(() => setSeconds((prev) => prev - 1), 1000);

        if (isFirstTry) {
          resendToken({ alertMessage: "Código de verificação enviado" });
          setIsFirstTry((prev) => !prev);
        }
      }
    } else {
      clearTimeout(timer);
    }
  }, [isModalVisible, seconds]);

  async function checkToken(e) {
    setLoading(true);
    await validUser({
      data: {
        id: tokenValidationId,
        token: e,
      },
    })
      .then(() => {
        if (type === "1") {
          setItem("tokenValidationEmail", tokenValidationId);
          codeInput.current.__clearvalues__();

          changeStep(taxId.replace(/\D/g, "").length > 11 ? 3 : 1);
        } else {
          setItem("tokenValidationSms", tokenValidationId);
          codeInput.current.__clearvalues__();

          changeStep(taxId.replace(/\D/g, "").length > 11 ? 5 : 3);
        }

        setLoading(false);
        setModalType(false);

        setIsFirstTry(true);
        setSeconds(defaultCoolDownSeconds);
      })
      .catch((err) => {
        message.error(err.response.data.message);
        setLoading(false);
      });
  }

  async function resendToken({ alertMessage }) {
    let data;

    if (type === "1") {
      data = {
        companyId,
        type,
        email: String(userEmail).toLowerCase(),
        fullName: userFullName,
      };
    } else {
      const phone = userPhone.replace(/\D/g, "");

      data = {
        companyId,
        type,
        number: `+55${phone}`,
      };
    }

    checkUser({ data })
      .then(({ data }) => {
        setTokenValidationId(data.id);
      })
      .then(() => {
        message.info(alertMessage);

        setSeconds(defaultCoolDownSeconds);
      })
      .catch((err) => {
        message.error(err.response.data.message);
        setLoading(false);
      });
  }

  return (
    <Modal
      title="Verificar contato"
      open={isModalVisible}
      onCancel={() => {
        setModalType(false);
      }}
      style={{ textAlign: "center" }}
      bodyStyle={{ textAlign: "left" }}
      width={600}
      footer={null}
    >
      <div className="container d-flex flex-column justify-content-center h-100">
        <Row justify="center">
          <Col xs={20} sm={20} md={20} lg={9}>
            <div className="my-2">
              <div className="text-center">
                <p className="mb-4">
                  Informe o código recebido por{" "}
                  <strong>
                    {(type === "1" && "E-mail") || (type === "2" && "SMS")}
                  </strong>
                </p>
              </div>
              <Row justify="center">
                <Col xs={24} sm={24} md={20} lg={20}>
                  <div className="__auth-code-input">
                    <ReactCodeInput
                      ref={codeInput}
                      onComplete={(e) => {
                        setSendButtonEnabled(true);
                        if (!loading) {
                          checkToken(e);
                        }
                      }}
                      type="number"
                      fields={6}
                    />
                  </div>
                </Col>
              </Row>
            </div>
            <div className="button-authentication d-flex justify-content-center">
              <Button
                onClick={() =>
                  resendToken({ alertMessage: "Enviamos um novo código" })
                }
                disabled={seconds > 0 || loading}
                className="__auth-m-sides-15"
              >
                {loading ? (
                  <LoadingOutlined />
                ) : seconds > 0 ? (
                  "Reenviar em " + seconds + "s"
                ) : (
                  "Reenviar"
                )}
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </Modal>
  );
}
